exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reset-password-form {\n  margin: 0 auto;\n}\n.reset-password-form__info-msg {\n  margin-bottom: 16px;\n}\n.reset-password-form__login {\n  margin-left: 16px;\n}\n", ""]);

// exports
